<h4>{{ accountKind }} {{ 'sp.revamp.accountDetailsPage.account' | translate }}</h4>
<div *ngIf="currentAccount.kind === '3a' && !isPossibleToCreate3A; else showDescription">
  <app-ui-info-box status="info">
    <p>{{ 'reinvest.3a.contribution.transferonly' | translate }}</p>
  </app-ui-info-box>
</div>
<ng-template #showDescription>
  <p>{{ 'sp.revamp.accountDetailsPage.accountKind.description' | translate: { account_kind: accountKind } }}</p>
</ng-template>

<div *ngIf="currentAccount.kind === '3a' && isPossibleToCreate3A" class="fund-possible-deposit">
  <p>
    <span>
      <strong>{{ 'reinvest.3a.contribution.stillpossible' | translate }}</strong>
      {{ stillPossibleToInvest | translateNumber: customer.language : currentAccount.currency }}
    </span>
    <app-ui-tooltip [content]="'reinvest.3a.contribution.tooltip' | translate" color="blue" size="medium"></app-ui-tooltip>
  </p>
</div>

<div class="fund-bank-details">
  <ng-container *ngIf="!(currentAccount.kind === '3a' && !isPossibleToCreate3A)">
    <ng-container *ngIf="currentAccount.kind !== '3a'">
      <div class="fund-bank-detail">
        <div>
          <p><strong>IBAN</strong></p>
          <p>{{ currentAccount.iban | iban }}</p>
        </div>
        <span
          ><a (click)="onCopyToClipboard(currentAccount.iban)"><img src="assets/images/reminder/copy-icon.svg" alt="Copy Icon" /></a
        ></span>
      </div>

      <div class="fund-bank-detail">
        <div>
          <p><strong>SWIFT/BIC</strong></p>
          <p>{{ 'steps.id5.saxo_funded.swiftBic' | translate }}</p>
        </div>
        <span
          ><a (click)="onCopyToClipboard('swift')"><img src="assets/images/reminder/copy-icon.svg" alt="Copy Icon" /></a
        ></span>
      </div>

      <div class="fund-bank-detail">
        <div>
          <p>
            <strong>{{ 'sp.revamp.accountDetailsPage.bankDetails' | translate }}</strong>
          </p>
          <p>{{ 'reinvest.bankAddress' | translate }}</p>
        </div>
        <span
          ><a (click)="onCopyToClipboard('address')"><img src="assets/images/reminder/copy-icon.svg" alt="Copy Icon" /></a
        ></span>
      </div>

      <div *ngIf="currentAccount.kind !== 'kid'" class="fund-bank-detail">
        <div>
          <p>
            <strong>{{ 'reinvest.beneficiary' | translate }}</strong>
          </p>
          <p>{{ customerName }}</p>
        </div>
        <span
          ><a (click)="onCopyToClipboard(customerName)"><img src="assets/images/reminder/copy-icon.svg" alt="Copy Icon" /></a
        ></span>
      </div>

      <ng-container *ngIf="currentAccount.kind === 'kid'">
        <br />
        <app-ui-info-box status="warning">
          <p>{{ 'sp.revamp.accountDetails.kids.warning' | translate: { mainAccount: customerName } }}</p>
        </app-ui-info-box>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="currentAccount.kind === '3a'">
      <div class="fund-bank-detail">
        <div>
          <p>
            <strong>{{ 'steps.id5.account_to_fund.deposit_box.bank' | translate }}</strong>
          </p>
          <p [innerHTML]="'sp.revamp.accountDetails.3a.hypiAddress' | translate"></p>
        </div>
        <span
          ><a (click)="onCopyToClipboard('hypiAddress')"><img src="assets/images/reminder/copy-icon.svg" alt="Copy Icon" /></a
        ></span>
      </div>

      <div class="fund-bank-detail">
        <div>
          <p>
            <strong>{{ 'steps.id5.account_to_fund.deposit_box.foundation' | translate | translate }}</strong>
          </p>
          <p [innerHTML]="'sp.revamp.accountDetails.3a.libertyAddress' | translate"></p>
        </div>
        <span
          ><a (click)="onCopyToClipboard('libertyAddress')"><img src="assets/images/reminder/copy-icon.svg" alt="Copy Icon" /></a
        ></span>
      </div>

      <div class="fund-bank-detail">
        <div>
          <p>
            <strong>{{ 'reinvest.account' | translate }}</strong>
          </p>
          <p>{{ currentAccount.liberty_account.qr_iban }}</p>
        </div>
        <span
          ><a (click)="onCopyToClipboard(currentAccount.liberty_account.qr_iban)"
            ><img src="assets/images/reminder/copy-icon.svg" alt="Copy Icon" /></a
        ></span>
      </div>

      <div class="fund-bank-detail">
        <div>
          <p>
            <strong>{{ 'reinvest.reference' | translate }}</strong>
          </p>
          <p>{{ currentAccount.liberty_account.reference_number }}</p>
        </div>
        <span
          ><a (click)="onCopyToClipboard(currentAccount.liberty_account.reference_number)"
            ><img src="assets/images/reminder/copy-icon.svg" alt="Copy Icon" /></a
        ></span>
      </div>
    </ng-container>
    <br />
    <app-deposit-delay-info [addMargin]="currentAccount.kind === '3a'"></app-deposit-delay-info>
  </ng-container>
  <ng-container *ngIf="currentAccount.kind === '3a'">
    <h4>{{ 'reinvest.transfer_title' | translate }}</h4>
    <app-transfer-3a-account></app-transfer-3a-account>
  </ng-container>
</div>

<div class="fund-client-details" *ngIf="customer.app_location !== 'ch' && financialDetails !== null">
  <h4>{{ 'sp.revamp.accountDetailsPage.personal.title' | translate }}</h4>
  <p>
    {{ 'sp.revamp.accountDetailsPage.personal.description' | translate }}
  </p>

  <div class="fund-bank-details">
    <app-ui-info-box status="warning">
      <p>
        {{ 'sp.revamp.accountDetailsPage.personal.warning' | translate }}
        <a (click)="onContactSupport()">{{ 'sp.revamp.accountDetailsPage.personal.link' | translate }}</a>
      </p>
    </app-ui-info-box>
    <br />

    <div class="fund-bank-detail">
      <div>
        <p><strong>IBAN</strong></p>
        <p>{{ financialDetails?.iban }}</p>
      </div>
    </div>

    <div class="fund-bank-detail">
      <div>
        <p><strong>SWIFT/BIC</strong></p>
        <p>{{ financialDetails?.bank?.bic }}</p>
      </div>
    </div>

    <div class="fund-bank-detail">
      <div>
        <p>
          <strong>{{ financialDetails?.bank?.bank }}</strong>
        </p>
        <p>
          {{ financialDetails?.bank?.address }}, {{ financialDetails?.bank?.zip }} {{ financialDetails?.bank?.city }},
          {{ financialDetails?.bank?.country }}
        </p>
      </div>
    </div>

    <div class="fund-bank-detail">
      <div>
        <p>
          <strong>{{ 'reinvest.beneficiary' | translate }}</strong>
        </p>
        <p>{{ customerName }}</p>
      </div>
    </div>
  </div>
</div>
